import { Injectable, ErrorHandler } from '@angular/core';
import { TelemetryService } from '../services/app-insights.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {

  constructor(private telemetryService: TelemetryService) {
      super();
  }

  override handleError(error: Error) {
      this.telemetryService.logException(error); // Manually log exception
  }
}
